import * as z from 'zod'
import {isValidPhoneNumber} from 'libphonenumber-js'

// sorting schema compatible with react-table
export const SortSchema = z.object({
  id: z.string(),
  desc: z.boolean(),
})
export type SortSchema = z.infer<typeof SortSchema>

export const DateValueSchema = z.object({
  calendar: z.object({identifier: z.string()}),
  day: z.int(),
  month: z.int(),
  year: z.int(),
  era: z.string(),
})
export type DateValueSchema = z.infer<typeof DateValueSchema>

export function validatePhone(payload: {required: true}): z.ZodString
export function validatePhone(payload?: {required?: false}): z.ZodOptional<z.ZodString>
export function validatePhone(payload?: {required?: boolean}) {
  const schema = payload?.required ? z.string({error: 'this_field_is_required'}) : z.string().optional()

  return schema.superRefine((value, ctx) => {
    if (typeof value === 'string' && value && !isValidPhoneNumber(value)) {
      ctx.addIssue({
        code: 'custom',
        path: [],
        continue: true,
        message: 'invalid_phone',
      })
    }
  })
}
